module.exports = __webpack_public_path__ + "e90b002b6f8eada51b7a8d0fd28a0576.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Pachantiew/5.jpg
// module id = 1364
// module chunks = 47